import OneSignal from "react-onesignal"

interface Settings {
  App: string
  Name: string
  baseURL: string
  BasePathForAPI: string
  BasePath: string
  GoogleMapsKey: string
  SignalURL: string
  OneSignalAppId: string
  Roles: {
    Admin: string
    User: string
  }
}

const settings: Settings = {
  App: "ShearlyBI",
  Name: "ShearlyBI",
  baseURL: "./",
  BasePathForAPI:
    process.env.REACT_APP_API_URL || "https://api.bi.shearly.com/api/",
  BasePath: process.env.REACT_APP_BASE_URL || "https://api.bi.shearly.com/",
  GoogleMapsKey:
    process.env.REACT_APP_GOOGLE_MAPS_KEY ||
    "AIzaSyA5c0WhOqMatPEDmy2RGIBfvhSR9GFOr5k",
  SignalURL:
    process.env.REACT_APP_SIGNAL_URL ||
    "https://signal2.shearly.com/communicationHub",
  OneSignalAppId:
    process.env.REACT_APP_ONESIGNAL_ID ||
    "a46b5373-ac0b-4dd0-b92a-fc093cac876e",
  Roles: {
    Admin: "admin",
    User: "user",
  },
}

export default settings
